export const interweave = <T>(arr: T[], item: T): T[] =>
  ([] as T[]).concat(...arr.map(n => [n, item])).slice(0, -1)

export const halfString = (s: string): [string, string] => {
  let middle = Math.floor(s.length / 2)
  const before = s.lastIndexOf(' ', middle)
  const after = s.indexOf(' ', middle + 1)

  if (before === -1 || (after !== -1 && middle - before >= after - middle)) {
    middle = after
  } else {
    middle = before
  }

  const s1 = s.substr(0, middle)
  const s2 = s.substr(middle + 1)

  return [s1, s2] as [string, string]
}
